/**
 * @file
 * Tabs JS functions.
 *
 * Modify the url when switching tabs
 * Show the tab that was chosen with the URL
 * Append the URL identifier to the `action` of forms in the tab content.
 *
 * This requires that the ids of all tabbed content start with "tab-".
 *
 * This is due to a bug or feature in Firefox.
 * Firefox has his own opinion about where to place anchor elements referenced in the URL hash
 * and hence destroys the mechanism we use to show and hide the tab content.
 */

(function($, Drupal) {
  Drupal.behaviors.dopTabs = {
    attach() {
      const _this = this;
      const $tabs = $('[data-toggle="tab"]');

      $(once('dop-tabs', $tabs)).each(function () {
        $(this).on('click', function() {
          const href = $(this).attr('href');
          const hash = _this.remove_prefix(href);
          window.history.replaceState(null, null, hash);
        });
      });

      $tabs.each(function() {
        const href = $(this).attr('href');
        const hash = _this.remove_prefix(href);
        if (hash === window.location.hash) {
          $(this).tab('show');
        }
        const $forms = $(href + ' form');
        $forms.each(function() {
          let action = $(this).attr('action');
          action += hash;
          $(this).attr('action', action);
        });
      });
    },
    remove_prefix(str) {
      /* remove the prefix "tab-" but keep the starting "#". */
      return '#' + str.substr(5);
    },
  };
})(jQuery, Drupal, once);
